import { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import { useNavigate, useParams } from "react-router-dom";
import Quiz from '../Exams/Quiz';
import { Modal, Button } from "react-bootstrap";
import { PDFDownloadLink } from '@react-pdf/renderer';
import KETPdf from "../KET/KETPdf"; // adjust the path as needed
import Swal from 'sweetalert2'
import { formatDate } from '../Utils/Utils'
import StaffProfilePDF from "./StaffProfilePDF";



const StaffProfile = () => {
    const { user_id } = useParams();
    const navigate = useNavigate();
    const [role_id, setRole_id] = useState(0);
    const [staffRoleId, setStaffRoleId] = useState(0);
    const [site_id, setSiteId] = useState(0);
    const [siteAddress, setSiteAddress] = useState("");
    const [localUser_id, setLocalUser_Id] = useState(0);
    const [userDetails, setUserDetails] = useState({});
    const [kets, setKets] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [allSites, setAllSites] = useState([]);
    const [formSections, setFormSections] = useState([
        {
            heading: "Section A | Details of Employment",
            fields: [
                { inputType: "text", field: "Company Name", key: "companyName" },
                { inputType: "text", field: "Employee Name", key: "employeeName" },
                { inputType: "text", field: "Employee NRIC/FIN", key: "nricOrFin" },
                { inputType: "text", field: "Employment Start Date", key: "employmentStartDate" },
                { inputType: "text", field: "Employment End Date (Only applicable for Fixed Term Contract)", key: "employmentEndDate" },
                { inputType: "text", field: "Job title", key: "jobTitle" },
                { inputType: "text", field: "Main Duties and Responsibilities", key: "duties" },
                { inputType: "text", field: "Employment Type", key: "employmentType" },
                { inputType: "text", field: "Site Name", key: "siteName" },
                { inputType: "text", field: "Place of work", key: "nricOrFin" },

            ]
        },
        {
            heading: "Section B | Working Hours and rest Days",
            fields: [

                { inputType: "text", field: "Details of working Hours", key: "workingHours" },
                { inputType: "number", field: "Number of working Days per week", key: "noOfWorkingDaysPerWeek" },
                { inputType: "text", field: "Break During Work", key: "breakHours" },
                { inputType: "text", field: "Rest Day (Specify)", key: "restDaysPerWeek" }
            ]
        },
        {
            heading: "Section C | Salary",
            fields: [
                { inputType: "text", field: "Salary Period", key: "salaryPeriod" },
                { inputType: "text", field: "Overtime Payment Period", key: "overtimeSalaryPeriod" },
                { inputType: "text", field: "Date(s) of salary Payment", key: "datesOfSalaryPayment" },
                { inputType: "text", field: "Date(s) of overtime Payment", key: "datesOfOvertimePayment" },
                { inputType: "text", field: "Effective Date", key: "salaryEffectiveDate" },
                { inputType: "number", field: "Basic Rate of Pay", key: "basicRateOfPay" },
                { inputType: "number", field: "Gross Rate of Pay", key: "basicRateOfPay" },
                { inputType: "number", field: "Overtime Rate of Pay", key: "overtimeRateOfPay" }
            ]
        },
        {
            heading: "Section D | Leave and Medical Benefits",
            fields: [
                { inputType: "text", field: "Paid Anual Leave per Year", key: "paidAnualLeavePerYear" },
                { inputType: "text", field: "Paid Outpatiend Sick Leave Per Year", key: "paidSickLeavePerYear" },
                { inputType: "text", field: "Paid Hospitalization Leave Per Year", key: "paidHospitalisationLeavePerYear" },
                { inputType: "text", field: "Others", key: "others" },
                { inputType: "text", field: "Medical Benefits", key: "medicalBenefits" }
            ]
        },
        {
            heading: "Section E | Others",
            fields: [
                { inputType: "text", field: "Length of Probation", key: "lengthOfProbation" },
                { inputType: "text", field: "Probation Start Date", key: "probationStartDate" },
                { inputType: "text", field: "Probation End Date", key: "probationEndDate" },
                { inputType: "text", field: "Termination Period During Probation", key: "terminationDuringProbation" },
                { inputType: "text", field: "Termination Period After Confirmation", key: "terminationAfterConfirmation" }
            ]
        }
    ]);
    const [leaveCategories, setLeaveCategories] = useState([]);
    const [leaveAllotment, setLeaveAllotment] = useState([]);
    const [quizSummary, setQuizSummary] = useState([]);
    const [addClicked, setAddClicked] = useState(false);
    const [isEditButtonClicked, setIsEditButtonClicked] = useState(false);
    const [needUpdateButton, setNeedUpdateButton] = useState(false);
    const [updatedAllotments, setUpdatedAllotments] = useState({});
    const [leaveCategory, setLeaveCategory] = useState([]);

    const leaveRefs = useRef({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = {
                    user_id: user_id,
                    status: 0
                };
                const token = localStorage.getItem("access_token");
                setLocalUser_Id(localStorage.getItem('user_id'));

                // Define custom headers
                const headers = {
                    access_token: token, // Pass the token in the Authorization header
                };
                const result = await Apiservice.GetUserById(data, headers);
                if (result.success === true || result.success === false) {
                    setLoading(false)
                }
                if (result.success) {
                    setUserDetails(result.data[0] || {});
                    setRole_id(localStorage.getItem('role_id'));
                    setStaffRoleId(result.data[0].role_id);
                    setSiteId(result.data[0].site_id);
                    setKets(result.data[0].kets);
                    setAllSites(result.data[0].sites);
                    setLeaveAllotment(result.data[0].leaveAllotment);
                    setLeaveCategories(result.data[0].leaveCategories);
                    //  console.log("result", result.data[0].kets)

                } else {
                    console.log(result, "result")
                    alert(result.message);
                }
            } catch (error) {
                console.error("Error fetching user details:", error);
                alert("Failed to fetch user details. Please try again.");
            }
        };
        fetchData();
    }, [user_id]);

    const handleNavigateToQuiz = () => {
        navigate(`/quiz/${user_id}`);
    };
    const handleDeleteConfirm = async () => {
        let data = {
            user_id: user_id,
            status: 0
        }
        const token = localStorage.getItem("access_token");

        // Define custom headers
        const headers = {
            access_token: token, // Pass the token in the Authorization header
        };
        let result = await Apiservice.SoftDeleteUser(data, headers);
        // console.log(result);
        if (result.success === true) {
            navigate('/allstaff');
        } else {
            alert(result.message)
        }
    }
    const handleAddKET = async () => {
        if (!site_id || site_id === 0 || site_id === '0') {
            const result = await Swal.fire({
                title: "Assign Site to Staff First?",
                text: "Do you want to assign a site before adding a KET?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Assign Site",
                cancelButtonText: "No, Cancel"
            });

            if (result.isConfirmed) {
                navigate(`/staffedit/${user_id}`);
                await Swal.fire({
                    title: "Redirected",
                    text: "Please assign the site before proceeding.",
                    icon: "info"
                });
            }
        } else {
            navigate('/ket', {
                state: {
                    user_id,
                    site_id,
                    staffRoleId
                }
            });
        }
    };


    const handleEdit = async () => {
        navigate(`/staffedit/${user_id}`)
    }

    const handleCheckIn = async (data) => {
        navigate(`/staffattendance/${data.id}`);
    }

    const findSitename = (id) => {
        const site = allSites.find((site) => site.id === id);
        return site ? site.name : "";
    };

    const getSiteAddress = (siteId) => {
        const site = allSites.find(site => site.id === parseInt(siteId));
        if (site && site.address) {
            return `${site.address.unitNo}, ${site.address.street}, ${site.address.country} - ${site.address.pincode}`;
        }
        return '';
    };

    useEffect(() => {
        const site = allSites.find(site => site.id === parseInt(site_id));
        if (site?.address) {
            const { unitNo, street, country, pincode } = site.address;
            const formatted = [unitNo, street, country].filter(Boolean).join(', ') + (pincode ? ` - ${pincode}` : '');
            setSiteAddress(formatted);
        } else {
            setSiteAddress('');
        }
    }, [site_id, allSites]);
    //console.log("userDetails", userDetails)

    const handleUpdateClick = (ketId) => {
        navigate('/ketedit', {
            state: {
                ketId
            }
        });
    }
    const getDaySuffix = (day) => {
        if (!day) return '';
        const j = day % 10, k = day % 100;
        if (j === 1 && k !== 11) return 'st';
        if (j === 2 && k !== 12) return 'nd';
        if (j === 3 && k !== 13) return 'rd';
        return 'th';
    };

    // Update state when input changes
    const handleInputChange = (id, value) => {
        setUpdatedAllotments((prev) => ({
            ...prev,
            [id]: value, // update only that row’s allotment
        }));
    };

    const handleSaveAllotments = async () => {
        // Collect values
        const leaveCategory = leaveCategories
            .filter((c) => !leaveAllotment.some((la) => la.leaveCategoryId === c.id))
            .map((c) => ({
                leaveCategoryId: c.id,
                allotedLeave: parseInt(leaveRefs.current[c.id]?.value || 0, 10),
            }))
            .filter((c) => c.allotedLeave > 0); // ✅ Only keep if > 0

        // If nothing to save, stop here
        if (leaveCategory.length === 0) {
            Swal.fire({ title: "No leave to save!", icon: "info" });
            return;
        }

        const payload = {
            year: 2025,
            userId: user_id,
            leaveCategory,
        };

        try {
            let result = await Apiservice.LeaveAllotmentAdd(payload);
            if (result.success) {
                Swal.fire({ title: "Saved Successfully!", icon: "success" });
                //  getLeaveAllotments(); // 🔄 refresh table data instead of reload
                setAddClicked(false); // close add section if needed
            } else {
                Swal.fire({ title: result.message, icon: "error" });
            }
        } catch (error) {
            Swal.fire({ title: "Error saving data", text: error.message, icon: "error" });
        }
    };




    // Submit update for one row
    const handleLeaveAllotmentUpdate = async (id) => {
        let data = {
            id,
            updatedAllotmentLeave: updatedAllotments[id]
        };

        let result = await Apiservice.LeaveAllotmentUpdate(data);
        if (result.success === true) {
            Swal.fire({
                title: "Updated Successfully!",
                icon: "success",
            });

            // Reset the updated value so button hides
            setUpdatedAllotments((prev) => {
                const newState = { ...prev };
                delete newState[id]; // remove this row from updatedAllotments
                return newState;
            });

            // Optional: refresh allotments from backend so balanceLeave also updates
            // fetchLeaveAllotments();
        }
    };

    return (
        <div className="container-fluid p-md-2 p-0 shadow" style={{userSelect: 'none' }}>
            {
                loading ? (
                    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                        <div className="text-center">
                            {/* Spinner with proper rotation */}
                            <div
                                className="spinner-border text-primary"
                                role="status"
                                style={{
                                    width: "2rem",
                                    height: "2rem",
                                    borderWidth: "3px",
                                }}
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            {/* Minimalist Text */}
                            <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                        </div>
                    </div>
                )
                    :
                    (
                        <>
                            <div className="row mb-2">
                                {role_id == 1 && localUser_id === user_id ? null : (
                                    role_id == 1 && (
                                        <>
                                            <div className="col text-end">
                                                <PDFDownloadLink
                                                    document={<StaffProfilePDF userDetails={userDetails} quizSummary={quizSummary} />}
                                                    fileName={`Staff_Profile_${userDetails.employeeId}.pdf`}
                                                    className="btn btn-primary"
                                                >
                                                    {({ loading }) => (loading ? "Generating PDF..." : "Download Profile PDF")}
                                                </PDFDownloadLink>

                                                {/* <button
                                                    className="btn btn-success btn-sm me-2"
                                                    onClick={()=>handleCheckIn(userDetails)}
                                                    style={{ cursor: 'pointer' }} // Ensures proper pointer cursor
                                                >
                                                    Check In
                                                </button> */}
                                                <button
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => setDeleteModal(true)}
                                                    style={{ cursor: 'pointer' }} // Ensures proper pointer cursor
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </>
                                    )
                                )}
                            </div>
                            <div className="row mb-2">
                                <div className="col-12">
                                    <div className="row border border-2-black p-md-2 p-0 m-md-2 m-1 shadow">
                                        <div className="container mt-3">
                                            <div className="row justify-content-center align-items-center">
                                                <div className="col-sm-4 col-md-3 text-center">
                                                    {userDetails.profileImage ? (
                                                        <img
                                                            src={userDetails.profileImage}
                                                            alt="Profile"
                                                            className="img-fluid border"
                                                            style={{ maxWidth: '150px', maxHeight: '150px', cursor: 'default' }} // No pointer changes
                                                        />
                                                    ) : (
                                                        <div
                                                            className="p-md-3 p-1 border rounded text-muted"
                                                            style={{ cursor: 'none' }} // Keeps the cursor static
                                                        >
                                                            <i className="bi bi-person-circle" style={{ fontSize: '4rem' }}></i>
                                                            <p>No profile image available</p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-sm-8 col-md-9">
                                                    {userDetails.firstName ? (
                                                        <div className="d-flex flex-column">
                                                            <h4 className="font-weight-bold">{`${userDetails.firstName} ${userDetails.lastName}`}</h4>
                                                            <span className="text-muted mb-1">{userDetails.role}</span>
                                                            <span className="text-muted mb-1">Employee ID : {userDetails.employeeId}</span>
                                                            <span className="text-muted mb-1">NRIC Or FIN : {userDetails.nricOrFin}</span>
                                                            <span className="text-muted mb-1">Contact No : {`${userDetails.countryCode} ${userDetails.mobileNo}`}</span>
                                                            <span className="text-muted mb-2">Email Id : {userDetails.emailId}</span>
                                                            <span className="col text-start">
                                                                {(role_id === 1 || role_id === '1') && (
                                                                    <>
                                                                        {
                                                                            kets.length == 0 && (<button className="btn btn-sm btn-primary me-2" onClick={handleAddKET}>Add KET</button>)
                                                                        }

                                                                        <button
                                                                            className="btn btn-sm btn-outline-primary mx-auto"
                                                                            onClick={handleEdit}
                                                                            style={{ cursor: 'pointer' }} // Ensures proper pointer cursor
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </>

                                                                )}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <p>User details not available</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        kets.length > 0 && (
                                            <>
                                                <div className="row">
                                                    <div className="col border border-2-black p-md-2 m-md-2">
                                                        <div className="accordion accordion-flush" id="accordionFlushExample">
                                                            <div className="accordion-item">
                                                                <h2 className="accordion-header">
                                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                                        KEY EMPLOYMENT TERMS
                                                                    </button>
                                                                </h2>
                                                                <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                                                    <div className="accordion-body">
                                                                        <div className="row">
                                                                            <div className="col">
                                                                                <div className="row">
                                                                                    <div className="col text-end">
                                                                                        <button className="btn btn-sm btn-outline-primary me-2" onClick={() => handleUpdateClick(kets[0].id)}>Update</button>
                                                                                        <PDFDownloadLink
                                                                                            document={<KETPdf kets={kets} userDetails={userDetails} siteAddress={siteAddress} />}
                                                                                            fileName={`KET_${userDetails.firstName || 'staff'}.pdf`}
                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                        >
                                                                                            {({ blob, url, loading, error }) =>
                                                                                                loading ? 'Generating PDF...' : 'Download PDF'
                                                                                            }
                                                                                        </PDFDownloadLink>

                                                                                    </div>
                                                                                </div>
                                                                                {formSections.map((section, secIndex) => (
                                                                                    <div key={secIndex}>
                                                                                        <h5 className="mt-4 mb-3">{section.heading}</h5>
                                                                                        {section.fields.map((item, fieldIndex) => (
                                                                                            kets.map((ket) => (
                                                                                                <>
                                                                                                    <div className="row mb-2" key={fieldIndex}>
                                                                                                        <div className="col-4">
                                                                                                            <label className="form-label">{item.field}</label>
                                                                                                        </div>
                                                                                                        <div className="col-1">:</div>
                                                                                                        <div className="col-4">
                                                                                                            {
                                                                                                                item.field === "Site Name" ? (
                                                                                                                    <input
                                                                                                                        type={item.inputType}
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        placeholder={item.field}
                                                                                                                        value={findSitename(kets[0].site_id)} readOnly
                                                                                                                    />
                                                                                                                ) : item.field === "Place of work" ? (
                                                                                                                    <input
                                                                                                                        type={item.inputType}
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        placeholder={item.field}
                                                                                                                        value={getSiteAddress(kets[0].site_id)} readOnly
                                                                                                                    />
                                                                                                                ) : (

                                                                                                                    <input
                                                                                                                        type={item.inputType}
                                                                                                                        className="form-control form-control-sm"
                                                                                                                        placeholder={item.field}
                                                                                                                        value={
                                                                                                                            item.inputType === 'date'
                                                                                                                                ? (ket[item.key] ? formatDate(ket[item.key]) : 'NA')
                                                                                                                                : (item.key === 'datesOfSalaryPayment' || item.key === 'datesOfOvertimePayment')
                                                                                                                                    ? (ket[item.key] ? `Every ${ket[item.key]}${getDaySuffix(ket[item.key])} of the month` : 'NA')
                                                                                                                                    : (ket[item.key] !== '' && ket[item.key] != null ? ket[item.key] : 'NA')
                                                                                                                        }
                                                                                                                        readOnly
                                                                                                                    />

                                                                                                                )
                                                                                                            }

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </>
                                                                                            ))


                                                                                        ))}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }

                                    {leaveAllotment.length > 0 && (
                                        <div className="row">
                                            <div className="col border border-2-black p-md-2 m-md-2 shadow-sm rounded">
                                                <div className="accordion accordion-flush" id="leaveAllotmentAccordion">
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header">
                                                            <button
                                                                className="accordion-button collapsed fw-bold"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapseLeave"
                                                                aria-expanded="false"
                                                                aria-controls="collapseLeave"
                                                            >
                                                                Leave Allotment
                                                            </button>
                                                        </h2>
                                                        <div
                                                            id="collapseLeave"
                                                            className="accordion-collapse collapse"
                                                            data-bs-parent="#leaveAllotmentAccordion"
                                                        >
                                                            <div className="accordion-body">
                                                                <div className="row">
                                                                    <div className="col text-end">
                                                                        <button className="btn btn-sm btn-primary" onClick={() => { setAddClicked(!addClicked); }}>Add</button>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    addClicked && (
                                                                        leaveCategories.length > 0 ? (
                                                                            <>
                                                                                {/* filter out categories that already exist in leaveAllotment */}
                                                                                {leaveCategories
                                                                                    .filter((c) => !leaveAllotment.some(la => la.leaveCategoryId === c.id))
                                                                                    .map((c) => (
                                                                                        <div className="row mb-2" key={c.id}>
                                                                                            <div className="col">{c.category}</div>
                                                                                            <div className="col-auto">:</div>
                                                                                            <div className="col">
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control form-control-sm"
                                                                                                    placeholder="Allotted leave"
                                                                                                    ref={(el) => (leaveRefs.current[c.id] = el)}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    ))
                                                                                }


                                                                                <div className="row">
                                                                                    <div className="col text-end">
                                                                                        <button
                                                                                            className="btn btn-sm btn-primary"
                                                                                            onClick={handleSaveAllotments}
                                                                                        >
                                                                                            Save
                                                                                        </button>
                                                                                    </div>
                                                                                </div>

                                                                            </>
                                                                        ) : (
                                                                            <h6>No leave categories</h6>
                                                                        )
                                                                    )
                                                                }


                                                                {leaveAllotment.length > 0 ? (
                                                                    <table className="table table-bordered table-hover text-center align-middle">
                                                                        <thead className="table-primary">
                                                                            <tr>
                                                                                <th>#</th>
                                                                                <th>Category</th>
                                                                                <th>Allotted Leave</th>
                                                                                <th>Balance Leave</th>
                                                                                <th>Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {leaveAllotment.map((item, index) => {
                                                                                const hasChanged =
                                                                                    updatedAllotments[item.id] !== undefined &&
                                                                                    updatedAllotments[item.id] != item.allotedLeave;

                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td>{index + 1}</td>
                                                                                        <td>{item.category}</td>
                                                                                        <td>
                                                                                            <input
                                                                                                type="number"
                                                                                                value={updatedAllotments[item.id] ?? item.allotedLeave}
                                                                                                disabled={!isEditButtonClicked}
                                                                                                onChange={(e) => handleInputChange(item.id, e.target.value)}
                                                                                            />
                                                                                        </td>
                                                                                        <td>{item.balanceLeave}</td>
                                                                                        <td>
                                                                                            <button
                                                                                                className="btn btn-sm btn-primary me-2"
                                                                                                onClick={() => {
                                                                                                    setIsEditButtonClicked(!isEditButtonClicked)
                                                                                                    setNeedUpdateButton(!needUpdateButton)
                                                                                                }}
                                                                                            >
                                                                                                Edit
                                                                                            </button>

                                                                                            {/* Show Update button only if this row actually changed */}
                                                                                            {hasChanged && (
                                                                                                <button
                                                                                                    className="btn btn-sm btn-success"
                                                                                                    onClick={() => handleLeaveAllotmentUpdate(item.id)}
                                                                                                >
                                                                                                    Update
                                                                                                </button>
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>



                                                                    </table>
                                                                ) : (
                                                                    <div className="text-muted text-center py-3">
                                                                        No leave allotments found
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="border border-2-black p-md-2 m-md-2">
                                        {/* <Quiz userId={user_id} navigate={handleNavigateToQuiz} userDetails={userDetails} /> */}
                                        <Quiz
                                            userId={user_id}
                                            navigate={handleNavigateToQuiz}
                                            userDetails={userDetails}
                                            setQuizSummary={setQuizSummary}
                                        />
                                    </div>
                                </div>
                            </div>
                            {deleteModal && (
                                <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Delete ?</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Are you sure you want to Delete?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="secondary"
                                            onClick={() => setDeleteModal(false)}
                                            style={{ cursor: 'pointer' }} // Ensures proper pointer cursor
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="danger"
                                            onClick={handleDeleteConfirm}
                                            style={{ cursor: 'pointer' }} // Ensures proper pointer cursor
                                        >
                                            Delete
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            )}
                        </>
                    )
            }

        </div >
    );

};

export default StaffProfile;
